module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1032-0290f8525295667806a725ab090777f1.png";